import { useQuery } from '@tanstack/react-query';
import { FetchResult, instance } from './config';
import { AxiosResponse } from 'axios';
import { ISequenceCutListItem } from '@types';

async function getSequenceCutList(
  id?: number,
  qs?: string
): Promise<AxiosResponse<FetchResult<ISequenceCutListItem[]>>> {
  const response = await instance.get(
    qs ? `/images/sequence?sequenceId=${id}${qs}&page=1&take=50` : `/images/sequence?sequenceId=${id}&page=1&take=50`
  );
  return response;
}

const useFetchSequenceCutList = (id?: number, qs?: string) => {
  const { data: originalData } = useQuery({
    queryKey: ['get', qs ? `/images/sequence?sequenceId=${id}${qs}` : `/images/sequence?sequenceId=${id}`],
    queryFn: () => getSequenceCutList(id, qs),
    retry: false,
    refetchOnWindowFocus: false,
    enabled: Boolean(id)
  });

  const data = originalData?.data.data;

  return { data };
};

export default useFetchSequenceCutList;
